// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__3VUYU","image":"index_image__35Pj5"};